import { render, staticRenderFns } from "./DocumentEPUAPSubmit.vue?vue&type=template&id=5a8fea53&"
import script from "./DocumentEPUAPSubmit.vue?vue&type=script&lang=js&"
export * from "./DocumentEPUAPSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports